if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', class HeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.prevButton = this.querySelector('[data-hero-prev]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.status = this.querySelector('[data-hero-status]');
      this.index = 0;
      this.paused = false;
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);

      if (this.slides.length < 2) {
        const controls = this.querySelector('.football-hero-carousel__controls');
        if (controls) controls.hidden = true;
        return;
      }

      this.prevButton?.addEventListener('click', () => this.show(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.pauseButton?.addEventListener('click', () => this.togglePause());

      this.addEventListener('mouseenter', () => this.stopTimer());
      this.addEventListener('mouseleave', () => this.startTimer());
      this.addEventListener('focusin', () => this.stopTimer());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.startTimer();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
        if (event.key === 'ArrowRight') this.show(this.index + 1, true);
      });

      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    show(nextIndex, announce = false) {
      const total = this.slides.length;
      this.index = (nextIndex + total) % total;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      if (announce && this.status) {
        this.status.textContent = 'Banner ' + (this.index + 1) + ' of ' + total;
      }

      this.restartTimer();
    }

    togglePause() {
      this.paused = !this.paused;
      this.pauseButton?.classList.toggle('is-paused', this.paused);
      this.pauseButton?.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton?.setAttribute('aria-label', this.paused ? 'Resume banner rotation' : 'Pause banner rotation');

      if (this.paused) this.stopTimer();
      else this.startTimer();
    }

    startTimer() {
      if (!this.autoplay || this.paused || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
    }

    stopTimer() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartTimer() {
      this.stopTimer();
      this.startTimer();
    }
  });
}
